// RevenueChart.js
import { Empty } from "antd";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Chart } from "react-chartjs-2";
import React from "react";

// Registrar os componentes necessários do Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineController
);

const RevenueChart = ({
  labels = [],
  permanenceData = [],
  faturamento_data = [],
}) => {
  if (!labels || !Array.isArray(labels) || labels.length === 0) {
    return (
      <Empty
        description="Não há dados de faturamento disponíveis para o período selecionado"
        style={{ margin: "20px 0" }}
      />
    );
  }

  const permanenceMap = new Map();
  if (permanenceData && Array.isArray(permanenceData)) {
    permanenceData.forEach((item) => {
      if (item && item.date && typeof item.occupation === "number") {
        permanenceMap.set(item.date, item.occupation);
      }
    });
  }

  const data = {
    labels,
    datasets: [],
  };

  if (
    faturamento_data &&
    Array.isArray(faturamento_data) &&
    faturamento_data.length > 0
  ) {
    data.datasets.push({
      type: "line",
      label: "Faturamento (R$)",
      data: faturamento_data,
      borderColor: "green",
      backgroundColor: "green",
      yAxisID: "y-axis-faturamento",
      fill: false,
      tension: 0.1,
    });
  }

  const peopleData = labels.map((date) => permanenceMap.get(date) || 0);

  data.datasets.push({
    type: "bar",
    label: "Permanência (min)",
    data: peopleData,
    backgroundColor: "rgba(45, 45, 45, 0.8)",
    borderColor: "rgba(45, 45, 45, 1)",
    borderWidth: 1,
    yAxisID: "y-axis-entrada",
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Agregação (Data)",
        },
      },
      "y-axis-entrada": {
        type: "linear",
        position: "left",
        title: {
          display: true,
          text: "Permanência (min)",
        },
        beginAtZero: true,
      },
      "y-axis-faturamento": {
        type: "linear",
        position: "right",
        title: {
          display: true,
          text: "Faturamento (R$)",
        },
        beginAtZero: true,
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  return (
    <div style={{ height: "400px" }}>
      <Chart data={data} options={options} />
    </div>
  );
};

export default RevenueChart;
